import { SiteId } from "@ubnt/store.core/lib/contexts/MenuContext/mapping";
import image from "../../assets/physical-security/ai-theta-lenses/ai-theta-pro.png";
import { type Product } from "../../types";
import { physicalSecurityInteriorDesign } from "../product-list-groups/physicalSecurityInteriorDesign";
import { deployment } from "../properties/deployment";
import { outdoorReady } from "../properties/outdoorReady";

export const aiThetaPro: Product = {
  id: "thetaPro",
  productTitle: "AI Theta Pro",
  techspecsPath: [SiteId.TechSpecs, "/unifi/cameras-nvrs/uvc-ai-theta-pro"],
  storePathParts: {
    productSlug: "uvc-ai-theta-pro",
    category: "cameras-theta",
  },
  sku: "UVC-AI-Theta-Pro",
  description: "thetaPro.description",
  image: { src: image, width: 200, height: 140 },
  productListGroup: physicalSecurityInteriorDesign,
  propertyValues: [
    {
      propertyId: "dimensions",
      value: {
        type: "string",
        value:
          "UVC-AI-Theta-Hub:\n140 x 70 x 38 mm\n(5.5 x 2.8 x 1.5”)\n\n\nUVC-AI-Theta-ProLens360:\nØ36.6 x 58.9 mm\n(Ø1.4 x 2.3”)\n\n\nUVC-AI-Theta-ProLens360 Flush mount:\nØ54.6 x 60.4 mm\n (Ø2.2 x 2.4”)",
      },
    },
    {
      propertyId: "cameraResolution",
      value: { type: "string", value: "4K" },
    },
    {
      propertyId: "imageSensor",
      value: { type: "string", value: '8MP 1/1.8" CMOS' },
    },
    {
      propertyId: "fieldOfView",
      value: {
        type: "translation",
        value: "thetaPro.fieldOfView",
      },
    },
    {
      propertyId: "nightVision",
      value: { type: "boolean", value: false },
    },
    {
      propertyId: "faceRecognition",
      value: { type: "translation", value: "thetaPro.faceRecognition" },
    },
    {
      propertyId: "opticalZoom",
      value: { type: "boolean", value: false },
    },
    {
      propertyId: "smartDetections",
      value: { type: "boolean", value: true },
    },
    {
      propertyId: "enhancedDetections",
      value: { type: "boolean", value: true },
    },
    {
      propertyId: "licensePlateRecognition",
      value: {
        type: "translation",
        value: "thetaPro.licensePlateRecognition",
      },
    },
    {
      propertyId: "aiRecognition",
      value: {
        type: "translation",
        value: "thetaPro.aiRecognition",
      },
    },
    {
      propertyId: "cameraAudio",
      value: {
        type: "translation",
        value: "thetaPro.cameraAudio",
      },
    },
    {
      propertyId: outdoorReady.id,
      value: { type: "boolean", value: false },
    },
    {
      propertyId: "tamperResistance",
      value: { type: "boolean", value: false },
    },
    {
      propertyId: deployment.id,
      value: { type: "string", value: "PoE" },
    },
  ],
};
